import security    from "../../../../main"

export default {
    masterdata () {
        return security.isMasterdataAdmin();
    },

    liftmanager () {
        return security.isLiftmanager();
    },

    admin () {
        return security.isAdmin();
    },

    privileged () {
        return security.isPrivileged();
    },

    planner () {
        return security.isPlanner();
    },

    prod () {
        return security.isProd();
    }
}